import { render, staticRenderFns } from "./ed-section-material-creator.vue?vue&type=template&id=0d2a8e8e&scoped=true&"
import script from "./ed-section-material-creator.ts?vue&type=script&lang=ts&"
export * from "./ed-section-material-creator.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-material-creator.scss?vue&type=style&index=0&id=0d2a8e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a8e8e",
  null
  
)

export default component.exports